var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.away,
          expression: "away"
        }
      ],
      staticClass: "role-menu-wrap"
    },
    [
      _c(
        "v-btn",
        {
          attrs: { flat: "", type: "submit", color: "primary" },
          on: {
            click: function($event) {
              return _vm.toggle()
            }
          }
        },
        [_c("v-icon", [_vm._v("supervisor_account")])],
        1
      ),
      _vm._v(" "),
      _vm.isActive
        ? _c(
            "v-list",
            { staticClass: "role-list", attrs: { raised: "" } },
            _vm._l(_vm.allowedCognitoGroups, function(item) {
              return _c(
                "v-list-tile",
                {
                  key: item,
                  class: { active: item === _vm.activeCognitoGroup },
                  on: {
                    click: function($event) {
                      return _vm.switchRole(item)
                    }
                  }
                },
                [
                  _c(
                    "v-list-tile-title",
                    { domProps: { textContent: _vm._s(item) } },
                    [_vm._v("{item}")]
                  )
                ],
                1
              )
            }),
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9dc549ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9dc549ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RoleGroup.vue
// module id = null
// module chunks = 